import http from "./http";

function getProfiles(params) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/configurations/${application}/profiles`, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export default {
  getProfiles,
};
